import React, { useCallback } from 'react';
import { PiEnvelopeSimple } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { Input } from 'rizzui';
import PhoneInput from '../../../../../components/forms/PhoneInputWrapper';
import useFetch from '../../../../../hooks/useFetch';
import FormGroup from '../../../../../layout/shared/form-group';
import { ClientService } from '../../../../../services/client/clientService';
import { ClientApiResponse } from '../../../../../type/entities/client-type';
import ClientProfileLayout from '../../ClientProfileLayout';

interface ClientInfoProps { }

const ClientInfo: React.FC<ClientInfoProps> = () => {

    const { id = '' } = useParams<{ id: string }>();
    const service = new ClientService();

    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getClientById(id);
        return response.getResponseData() as ClientApiResponse;
    }, [id]));

    return (
        <ClientProfileLayout isLoading={loading}>
            <div className="@container">
                <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                    <FormGroup
                        title="Información General"
                        description="Datos principales"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <Input
                            disabled
                            label="Name"
                            placeholder="Nombre del cliente"
                            value={data?.name ?? ""}
                        />
                        <Input
                            disabled
                            label="Dirección"
                            className="md:col-span-3"
                            value={data?.address ?? ""}
                        />
                    </FormGroup>

                    <FormGroup
                        title="Contacto"
                        description="Datos del Contacto"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-3"
                    >
                        <Input
                            disabled
                            label="Nombre y apellidos"
                            placeholder="Nombre del Contacto"
                            value={data?.contactName ?? ""}
                        />
                        <Input
                            prefix={<PiEnvelopeSimple className="h-6 w-6 text-gray-500" />}
                            label="Email"
                            placeholder="info@austros.es"
                            value={data?.contactEmail ?? ""}
                            disabled
                        />
                        <PhoneInput
                            id="contactPhone"
                            disabled
                            label="Teléfono"
                            placeholder="+34 123456789"
                            value={data?.contactPhone ?? ""}
                        />
                    </FormGroup>
                </div>
            </div>
        </ClientProfileLayout>
    );
};

export default ClientInfo;